import axios from 'axios'
import api_routes from '../../assets/js/api_routes';
import filterStations from '../../utils/filterStations'

const stationActions = {
        getStations({ commit }) {
                //TODO this function need refactoring for the async request (use async await in the refactoring)
                var access_token = localStorage.access_token
                var stations = []
                return new Promise((resolve, reject) => {
                        const hydro_data = {
                                typology: 'hydrometeorological',
                                token: access_token
                        }
                        const air_data = {
                                typology: 'airQuality',
                                token: access_token
                        }
                        const water_data = {
                                typology: 'groundWater',
                                token: access_token
                        }
                        axios.post(api_routes.get_stations_by_typology, hydro_data)
                        .then((resp) => {
                                resp.data.forEach((element) => {
                                let station = {
                                        name: element.station_name.replace('_', ' '),
                                        id: element.station_sk,
                                };
                                stations.push(station)
                                resolve(resp)
                                });
                                commit('add_hydro_station', stations)
                        })
                        .catch((err) => {
                                console.log(err);
                                reject(err)
                        });

                        axios.post(api_routes.get_stations_by_typology,air_data)
                        .then((resp) => {
                        resp.data.forEach((element) => {
                                let station = {
                                        name: element.station_name.replace('_', ' '),
                                        id: element.station_sk,
                                };
                                commit('add_air_station', station)
                                resolve(resp)
                                });
                        })
                        .catch((err) => {
                                console.log(err);
                                reject(err)
                        });

                        axios.post(api_routes.get_stations_by_typology,water_data)
                        .then((resp) => {
                        resp.data.forEach((element) => {
                                let station = {
                                        name: element.station_name.replace('_', ' '),
                                        id: element.station_sk,
                                };
                                commit('add_water_station', station)
                                resolve(resp)
                                });
                        })
                        .catch((err) => {
                                console.log(err);
                                reject(err)
                        });
                })
        },

        async getNameStationById({ commit },payload){
                let station_name = ''
                const access_token = localStorage.access_token
                const head = {
                        station_sk: payload.station_sk,
                        token: access_token
                }
                commit('change_state_loading')
                try{
                        const data_station_name = await axios.post(api_routes.get_station_name_by_id,head)
                        Object.values(data_station_name.data).forEach(values => {
                                Object.entries(values).forEach(([key,value])=> {
                                if(key === 'station_name') station_name = value
                                        commit('change_name_station', station_name)
                                })
                        })
                        commit('change_state_loading')
                } catch(err){
                        console.log("this is the error: " + err)
                        commit('change_state_loading')
                }
        },

        async getDataVariablesForStation({ commit }, payload) {
                const transformTypology = {
                        "hydrological": "hydrometeorological",
                        "hydrometeorological": "meteorological",
                }
                const adjustedTypology = transformTypology[payload.typology] || payload.typology;
                const access_token = localStorage.access_token;
                const head = {
                  station_id: parseInt(payload.station_id),
                  init_date: payload.init_date,
                  finish_date: payload.finish_date,
                  typology: adjustedTypology,
                  token: access_token
                };

                try {
                  const countDataVariablesResponse = await axios.post(api_routes.get_variables_by_station, head);
                  commit('get_available_variables', countDataVariablesResponse.data);
                  commit('change_mode_variables_air');
                } catch (err) {
                  console.log("This is the error: " + err);
                }
        },

        async getDataDatesForStation({ commit }, payload){
                commit('change_state_loading')
                const access_token = localStorage.access_token
                try{
                        const head = {
                                station_id: payload.station_id,
                                typology: payload.typology,
                                token: access_token
                        }
                        const dates = await axios.post(api_routes.get_dateRange_by_station_and_typology, head)
                        commit('get_dates', dates.data)
                        commit('change_state_loading')
                } catch( err ){
                        commit('change_state_loading')
                        console.log("this is the error: " + err)
                }
        },
        async getStationsInformation(context, newTypology) {
                const access_token = localStorage.access_token;
                try {
                  const head = {
                    token: access_token,
                    typology: newTypology
                  }
                  const response = await axios.post(api_routes.get_stations_by_typology, head)
                  const data = response.data
                  const dataStation = data.map(element => ({
                    idSimac: element.simac_code,
                    name: element.station_name,
                    municipality: element.municipality,
                    location: element.location,
                    altitude: element.altitude,
                    start_operation: element.start_operation,
                    id: element.id
                  }));
                  return filterStations(dataStation)
                } catch (error) {
                  console.log(error);
                }
        },
        downloadStationsInformation(){
                const fileURL = 'stationsInformation/informacion.xlsx';
                const link = document.createElement('a');
                link.href = fileURL;
                link.download = 'Listado_Estaciones.xlsx';
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
              
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        }
}

export default stationActions
